import { render, staticRenderFns } from "./GigExtensionForm.vue?vue&type=template&id=855af386&scoped=true&"
import script from "./GigExtensionForm.vue?vue&type=script&lang=js&"
export * from "./GigExtensionForm.vue?vue&type=script&lang=js&"
import style0 from "./GigExtensionForm.vue?vue&type=style&index=0&id=855af386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855af386",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
